import ContentLoader from '@space-core/components/contentLoader'
import { ShowcaseOrientation } from '@space-shell/common/services/membership'
import { SectionType } from '@space-shell/common/services/sections'

import styled from 'styled-components'

export type CardContentLoaderProps = {
  orientation: ShowcaseOrientation
  sectionType: SectionType
  isPreview?: boolean
}

const Container = styled.div<{ $orientation: ShowcaseOrientation }>`
  aspect-ratio: ${({ $orientation }) =>
    $orientation === ShowcaseOrientation.HORIZONTAL ? '16/9' : '9/13'};
  overflow: hidden;
`

const TitleLoader = styled(ContentLoader)`
  width: 80%;
`

const TitleLoaderNoAnimation = styled.div`
  width: 80%;
  height: var(--spacer-4);
`

const CardContentLoader = ({
  orientation,
  sectionType,
  isPreview = false
}: CardContentLoaderProps) => {
  const orientationLoader =
    sectionType === SectionType.MODULE
      ? ShowcaseOrientation.HORIZONTAL
      : orientation || ShowcaseOrientation.VERTICAL

  return (
    <div data-test='card-content-loader'>
      <Container $orientation={orientationLoader}>
        {isPreview ? (
          <div className='_w-full _bg-gray-200 _h-full _rounded-lg' />
        ) : (
          <ContentLoader className='_w-full _h-full _rounded-lg' />
        )}
      </Container>
      {sectionType !== SectionType.MODULE &&
        (isPreview ? (
          <TitleLoaderNoAnimation className='_bg-gray-200 _rounded _py-2 _mt-2 _mt-md-3 _mb-1' />
        ) : (
          <TitleLoader className='_mt-2 _mt-md-3 _mb-1' />
        ))}
    </div>
  )
}

export default CardContentLoader
